// = Libs =
import { FC, useState } from 'react';

// = Styles =
// = Imports =
import Page from '../../common/containers/page/page';
import Container from '@/common/containers/container/container';
import { SplitContent } from '@/common/containers/split-content/split-content';
import FilterSet, { InputField } from '@/components/filter-set/filter-set';
import { PollList } from '@/pages/catalog/poll-list/poll-list';
import {
  mapToAuthorCard,
  mapToExecutorCard,
  usePollList,
} from '@/services/poll.service';
import { useHistory, useParams } from 'react-router-dom';
import { UserRoles } from '@/constants/assist-values';
import { useOrgData } from '@/services/organization.service';
import Jumbotron from '@/common/components/core/jumbotron/jumbotron';
import classes from './catalog.module.scss';
import Button from '@/common/components/ui/buttons/button/button';

const Catalog: FC = () => {
  const { mode, orgId } = useParams<{ mode: UserRoles; orgId: string }>();
  const org = useOrgData(orgId);
  let [polls, setPolls] = useState([]);
  let [filters, setFilters] = useState({});

  const pollList = usePollList({
    limit: 20,
    offset: 0,
    mode: mode,
    // @ts-ignore TODO: добавить типизацию в filters
    query: filters['searchQuery'],
    mapping: mode === 'author' ? mapToAuthorCard : mapToExecutorCard,
    orgId: Number(orgId),
  });

  const filterConfig: InputField[] = [
    {
      name: 'searchQuery',
      value: false,
      text: 'Поиск',
      input: 'text',
    },
    {
      name: 'showPublic',
      value: false,
      text: 'Публичные опросы',
      input: 'checkbox',
    },
  ];

  const history = useHistory();
  const pathToCreateMonitoring = () => {
    history.push(`/polls/author/${orgId}/new`);
  };

  return (
    <Page>
      <Jumbotron
        title={
          mode === 'executor'
            ? 'Мониторинги к заполнению'
            : 'Созданные мониторинги'
        }
        subtitle={org?.name}
        previousPage={'Главная'}
        previousPath={'/'}
      />
      <Container>
        <SplitContent
          SideBar={
            <div className={classes.side}>
              {mode === 'author' && (
                <Button
                  color={'primary'}
                  onClick={pathToCreateMonitoring}
                  className={classes.create}>
                  Создать мониторинг
                </Button>
              )}
              <FilterSet
                state={filters}
                setState={setFilters}
                config={filterConfig}
              />
            </div>
          }
          Content={<PollList {...pollList} orgId={Number(orgId)} />}
        />
      </Container>
    </Page>
  );
};

export default Catalog;
